import { useSearch } from "../../api/hooks";
import { useUi } from "../../state/ui";
import { EventList } from "./EventList";

export function SearchView() {
  const ui = useUi();
  const { data, isLoading } = useSearch(ui.searchQuery);
  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <header className="search-head">
        <span className="eyebrow">Busca · {data?.events.length ?? 0} resultados</span>
        <h1 className="search-title display">“{ui.searchQuery}”</h1>
      </header>
      {isLoading ? (
        <div className="center-fill" style={{ height: 200 }}>
          <div className="spinner" />
        </div>
      ) : (
        <EventList events={data?.events ?? []} emptyText="Nenhum resultado encontrado." showYear />
      )}
    </div>
  );
}
